module.exports = __webpack_public_path__ + "2009c75a6c09cdf1706a5a5b17bc7351.svg";